<script lang="ts">
  import { Dialog } from "bits-ui";
  import { cn } from "$lib/utils/cn";
  import type { Snippet } from "svelte";

  interface Props {
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    title?: string;
    description?: string;
    class?: string;
    children: Snippet;
  }

  let {
    open = $bindable(false),
    onOpenChange,
    title,
    description,
    class: className,
    children,
  }: Props = $props();
</script>

<Dialog.Root bind:open {onOpenChange}>
  <Dialog.Portal>
    <Dialog.Overlay
      class="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm
             data-[state=open]:animate-in data-[state=closed]:animate-out
             data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
    />
    <Dialog.Content
      class={cn(
        "fixed left-1/2 top-1/2 z-50 w-full max-w-[500px] -translate-x-1/2 -translate-y-1/2",
        "bg-surface-2 border border-border-default rounded-lg shadow-2xl",
        "data-[state=open]:animate-in data-[state=closed]:animate-out",
        "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
        "data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%]",
        "data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
        "duration-200",
        className
      )}
    >
      {#if title || description}
        <div class="px-5 pt-5 pb-4 border-b border-border-subtle">
          {#if title}
            <Dialog.Title class="text-base font-medium text-text-primary">
              {title}
            </Dialog.Title>
          {/if}
          {#if description}
            <Dialog.Description class="mt-1 text-sm text-text-secondary">
              {description}
            </Dialog.Description>
          {/if}
        </div>
      {/if}

      <div class="p-5">
        {@render children()}
      </div>

      <Dialog.Close
        class="absolute right-3 top-3 h-6 w-6 flex items-center justify-center
               rounded text-text-muted hover:text-text-primary hover:bg-surface-3
               transition-colors"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
        </svg>
      </Dialog.Close>
    </Dialog.Content>
  </Dialog.Portal>
</Dialog.Root>
